import { generatePath, useNavigate, useParams, useRouteLoaderData } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { useTitle } from '../../../../../common/hooks/useTitle.js';
import { myOrdersMsg, omaElisaForEmployeeMsg, t } from '../../../../../common/i18n/index.js';
import { DeliveryOrderDetails } from '../../../../../components/DeliveryOrderDetails/DeliveryOrderDetails.js';
import type { DeliveryId, OrderId } from '../../../../../common/constants/pathInterfaces.js';
import type { UserCustomerOrderLoaderData } from '../../../../../common/loaders';

export const EoeOwnOrderItemPath = () => {
  const { customerOrder } = useRouteLoaderData('eoe-own-orders') as UserCustomerOrderLoaderData;
  const { deliveryId } = useParams<OrderId & DeliveryId>();
  const navigate = useNavigate();
  const deliveryOrder = customerOrder.deliveryOrders.find(e => e.deliveryOrderDisplayId === deliveryId);

  useTitle([
    t.H6JV(omaElisaForEmployeeMsg),
    t.EG6F(myOrdersMsg),
    customerOrder.customerOrderDisplayId ?? '',
    deliveryOrder?.deliveryOrderName ?? '',
  ]);

  if (!(customerOrder && deliveryOrder)) {
    return null;
  }

  return (
    <DeliveryOrderDetails
      customerOrder={customerOrder}
      deliveryOrder={deliveryOrder}
      breadCrumbPaths={[
        { name: t.H6JV(omaElisaForEmployeeMsg), path: paths.EMPLOYEE_HOME },
        { name: t.EG6F(myOrdersMsg), path: paths.EMPLOYEE_OWN_ORDERS },
        {
          name: customerOrder.customerOrderDisplayId,
          path: generatePath(paths.EMPLOYEE_OWN_ORDER, { orderId: customerOrder.customerOrderDisplayId }),
        },
        { name: deliveryOrder.deliveryOrderName },
      ]}
      onClickCustomerOrder={() => {
        navigate(generatePath(paths.EMPLOYEE_OWN_ORDER, { orderId: customerOrder.customerOrderDisplayId }));
      }}
      isApprover={false}
      showOrderConfirmationDownload={false}
    />
  );
};
